const camelCase = (string) => string
	.replace(/[_.-](\w|$)/g, (match, firstLetter) => {
		return firstLetter.toUpperCase();
	});

const walk = (object) => {
	if (!object || typeof object !== "object") {
		return object;
	}

	if (Array.isArray(object)) {
		return object.map(walk);
	}

	return Object
		.keys(object)
		.reduce((accumulator, key) => {
			const camelCasedKey = camelCase(key);

			return {
				...accumulator,
				[camelCasedKey]: walk(object[key]),
			};
		}, {});
};

const camelize = (objects) => {
	if (typeof objects === "string") {
		return camelCase(objects);
	}

	return walk(objects);
};

export default camelize;



// WEBPACK FOOTER //
// ./src/shared/payment/helpers/camelize.js